<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import ReferundumComponent from "@/component/project/ReferundumComponent.vue";

@Component({
  components: {ReferundumComponent, NavBar}
})
export default class ReferendumView extends Vue {

}
</script>

<template>
  <NavBar/>
  <div class="view-container">
    <ReferundumComponent/>
  </div>
</template>

<style scoped>
.view-container {
  margin-left: 80px;
  height: 100vh;
  background-color: var(--background-color);
  overflow-y: auto;
}
</style>